import Vue from 'vue';
import Router from 'vue-router';

// Views
import LayoutCentered from '@/views/layouts/Centered';
import LayoutMain from '@/views/layouts/Main';
import Dashboard from '@/views/Dashboard';

// Routes
import projectsRoutes from './routes/projects';
import projectRoutes from './routes/project';
import reportRoutes from './routes/report';
import settingsRoutes from './routes/settings';
import superUserRoutes from './routes/superUser';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '',
			component: LayoutMain,
			meta: {
				auth: true,
				title: 'Report Mule',
			},
			children: [
				{
					path: '',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						title: 'Dashboard',
					},
				},
				projectsRoutes, // '/projects'
				projectRoutes, // '/projects/:projectId'
				reportRoutes, // '/reports/:reportId'
				settingsRoutes, // '/settings'
				superUserRoutes, // '/super'
				{
					path: 'search',
					name: 'Search',
					component: () => import('@/views/Search'),
					meta: {
						title: 'Search',
					},
				},
				{
					path: 'error',
					component: () => import('@/views/Error'),
					name: 'Error',
					meta: {
						title: 'Error',
					},
				},
				{
					path: 'not-found',
					component: () => import('@/views/NotFound'),
					name: 'NotFound',
					meta: {
						title: 'Page Not Found',
					},
				},
			],
		},
		{
			path: '/login',
			component: LayoutCentered,
			children: [
				{
					path: '',
					name: 'Login',
					component: () => import('@/views/Login'),
					meta: {
						title: 'Login',
					},
				},
				{
					path: 'reset',
					name: 'ResetPassword',
					component: () => import('@/views/ResetPassword'),
					meta: {
						title: 'Reset Password',
					},
				},
			],
		},
		{
			path: '/register',
			component: LayoutCentered,
			children: [
				{
					path: '',
					name: 'CreateAccount',
					component: () => import('@/views/CreateAccount'),
					meta: {
						title: 'Create Account',
					},
				},
			],
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		return { x: 0, y: 0 };
	},
});

router.beforeEach((to, from, next) => {

	// Dynamic titles (report/project names) are done with the Route.vue which has access
	// to the data, the rest are handled here.
	if (!to.matched.some(record => record.meta.dynamic)) {
		document.title = `${to.meta.title} | Report Mule`;
	}

	const isLoggedIn = Boolean(localStorage.authKey) || Boolean(sessionStorage.authKey);

	// If has to be logged in
	// Supposed to find route with path: ''
	if (to.matched.some(record => record.meta.auth)) {

		// If not logged in, redirect to login page
		if (!isLoggedIn) {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath,
				},
			});
		}
		else {
			next();
		}
	}
	// For other cases: '/login', '/register', '/login/reset'
	else {
		if (localStorage.authKey) {
			// Redirect from login page if already logged in
			if (to.name === 'Login') {
				next({ name: 'Dashboard' });
			}
			// Guard for incorrect urls inside the app
			else if (from.name) {
				router.push({ name: 'Error' });
			}
			// Error page setting if user enters error page through direct url
			// Used to switch back button to a home button.
			else {
				router.replace({ name: 'Error', params: { to: { name: 'Dashboard' } } });
			}
			next(false);
		}
		else if (!localStorage.authKey && !to.matched.some(record => record)) {
			next({ name: 'Login' });
		}
		next();
	}
});

export default router;
